

export const getSetCurrency = () => {
	return document.getElementById('MC-selected').getAttribute('data-currency')
}

export const presentmentPrice = (setCurrency, presentmentPrices) => {
	const obj = presentmentPrices.edges.filter(obj => obj.node.price.currencyCode === setCurrency)[0]
	return `$${parseInt(obj.node.price.amount).toFixed(2)}`
}


export const presentmentPriceUnformatted = (setCurrency, presentmentPrices) => {
	const obj = presentmentPrices.edges.filter(obj => obj.node.price.currencyCode === setCurrency)[0]
	return parseInt(obj.node.price.amount).toFixed(2)
}



